/* eslint-disable import/prefer-default-export */
import { isClient } from './isClient';

export const logout = () => {
  if (isClient()) {
    localStorage.removeItem('access_token');
    window.history.replaceState({}, null, window.location.origin);
    // window.location.replace(window.location.origin);
  }
};
